<template>
  <div class="edit-user">
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog title="图片剪裁" :visible.sync="cropper" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <div style="width: auto;height:500px">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="option.info"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
            ></vueCropper>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropper = false">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
    <header>
      <p>
        当前位置：
        <span @click="() => {this.$router.push('/home')}">个人主页</span>
        <span style="margin: 0 10px">></span>
        <span style="color:#0090ff">编辑资料</span>
      </p>
    </header>
    <div class="main">
      <p class="title">音乐人信息</p>
      <div class="edit">
        <div class="row" style="height: 90px">
          <div class="left">
            <div class="label center-y">头像</div>
          </div>
          <div class="right">
            <div class="head-img">
              <img :src="avatar" alt srcset />
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(1)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">歌手名</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{this.authorName}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(2)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">性别</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{find('type', type)}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(3)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">地区</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{find('area', area)}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(4)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">身份</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{find('identity', identity)}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(5)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">流派</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{find('style', style)}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(7)">修改</div>
            </div>
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">授权平台</div>
          </div>
          <div class="right">
            <img class="center-y" src="../assets/img/logo.png" alt srcset style="width:80px" />
          </div>
        </div>
        <div class="row" style="height: 40px">
          <div class="left">
            <div class="label center-y">简介</div>
          </div>
          <div class="right">
            <div>
              <p class="text">{{intro}}</p>
              <div :class="`btn ${review_status == 1 ? 'disabled' : ''}`" @click="editInfo(6)">修改</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="popupFlag" class="popup-c">
      <div class="center popup">
        <div class="header">
          <div class="title">修改信息</div>
          <div class="close" @click="closePopup()">X</div>
        </div>
        <div class="main">
          <div v-show="popupType == '1'" class="edit-img">
            <p>
              1.图片需为jpg、jpeg、png格式
              <br />尺寸>500*500像素
            </p>
            <p>2.修改头像需经过审核，1个月只能修改1次</p>
            <div>
              <img :src="editHeadImg" alt />
            </div>
          </div>
          <div v-show="popupType == '2'" class="edit-text">
            <p>
              <input type="text" v-model="editName" maxlength="60"/>
            </p>
          </div>
          <div v-show="popupType == '3'" class="edit-radio">
            <el-radio
              v-for="(item, i) in typeArr"
              :key="i"
              v-model="editType"
              :label="item.type"
            >{{item.typeStr}}</el-radio>
          </div>
          <div v-show="popupType == '4'" class="edit-radio">
            <el-select v-model="editArea" placeholder="请选择">
              <el-option
                v-for="item in areaArr"
                :key="item.type"
                :label="item.typeStr"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>
          <div v-show="popupType == '5'" class="edit-radio">
            <el-select v-model="editIdentity" placeholder="请选择">
              <el-option
                v-for="item in identityArr"
                :key="item.type"
                :label="item.typeStr"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>
          <div v-show="popupType == '7'" class="edit-radio">
            <el-select v-model="editStyle" placeholder="请选择">
              <el-option
                v-for="item in styleArr"
                :key="item.type"
                :label="item.typeStr"
                :value="item.type"
              ></el-option>
            </el-select>
          </div>
          <div v-show="popupType == '6'" class="edit-textarea">
            <el-input
              type="textarea"
              :rows="6"
              :placeholder="introPlaceholder"
              resize="none"
              v-model="editIntro"
            ></el-input>
          </div>
          <div class="bottom">
            <div v-show="popupType != 1" class="left" @click="closePopup()">取消</div>
            <div v-show="popupType == 1" class="left" @click="autoClick()">更改图片</div>
            <input style="display:none" type="file" name id="headUpload" accept=".jpg, .png, .jpeg" />
            <div class="right" @click="edit()">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadBase64Img } from "../lib/api";
// import areaArray from "../data/area.json";
export default {
  data() {
    return {
      introPlaceholder: '个人简介（10-2000字），填写后将展示在歌手详细信息中，可参考以下内容：  \n个人信息：90后创作歌手  \n主要成就：腾讯音乐娱乐盛典最佳男/女歌手  \n代表作品：《***》',
      user: {},
      intro:"",
      editIntro: "",
      authorName: "",
      editName: "",
      editHeadImg: require('../assets/img/default.png'),
      avatar: require('../assets/img/default.png'),
      popupFlag: false,
      //1头像2歌手名3类型4地区5身份6简介7流派
      popupType: "1",
      typeArr: [],
      areaArr: [],
      countryArr: [],
      styleArr: [],
      identityArr: [],
      area: 0,
      editArea: 0,
      identity: 0,
      editIdentity: 0,
      country: 1,
      style: 0,
      editStyle: 0,
      type: 0,
      editType: 0,
      option: {
        img: "", // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 10, // 默认生成截图框宽度
        // autoCropHeight: 10, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMove: false, //原图是否能拖动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      loading: false,
      cropper: false,
      review_status: 1
    };
  },
  created() {
    this.getBaseConfig();
  },
  mounted() {
    this.event();
    this.$nextTick(() => {
      this.myStatus()
    })
  },
  methods: {
    editInfo(index) {
      if(this.review_status == 1) {
        window.eventEmitter.emit('toast', '您的歌手资料更改审核中')
      } else {
        this.showPopup(index)
      }
    },
      //查找
      find(type, value) {
        const obj = this[type + 'Arr'].find(item => item.type == value)
        return obj && obj.typeStr || ''
      },
      //获取我的信息
      myStatus(cb) {
        this.api({
            apiName: 'myStatus',
            methods: 'GET',
            getData: {
                biz: 'musician_author_dj'
            }
        }).then(res => {
            console.log(res)
            //const data = res.data.info
            //已入驻，用线上数据;线上数据null，则用提交审核的数据
            this.review_status = res.data.info.review_status
            const data = res.data.is_settle ? (res.data.released_info ? res.data.released_info : res.data.info) : res.data.info
            this.user = data
            this.avatar = data.avatar
            this.editHeadImg = data.avatar
            this.authorName = data.author_name
            this.editName = data.author_name
            this.type = data.gender
            this.editType = data.gender
            this.area = data.area
            this.editArea = data.area
            this.identity = data.identity
            this.editIdentity = data.identity
            this.intro = data.intro
            this.editIntro = data.intro
            this.style = data.genre
            this.editStyle = data.genre
        })
    },
    updateUser(data) {
      this.api({
        apiName: 'submitSettle',
        postData: Object.assign({
          typ: 4
        }, data)
      }).then(res => {
        console.log(res)
        this.myStatus()
      }).catch(err => {
        window.eventEmitter.emit('toast', err.errmsg || '服务器异常')
      })
    },
    //选择框基础配置
    async getBaseConfig() {
      //接口500或返回数组null使用默认
      try {
        let res = (
          await this.api({
            apiName: "baseConfig",
            methods: "GET",
            getData: {
              category: "1,2,3,4,5",
            },
          })
        )
        if(res.errcode == 0) {
          const data = res.data.data;
          this.typeArr = data["1"].length != 0 ? data["1"] : [{typeStr: "男", type: 0}];
          this.areaArr = data["2"].length != 0 ? data["2"] : [{typeStr: "内地", type: 0}];
          this.identityArr = data["3"].length != 0 ? data["3"] : [{typeStr: "演唱", type: 0}];
          this.styleArr = data["4"].length != 0 ? data["4"] : [{typeStr: "流行", type: 0}];
          this.countryArr = data["5"].length != 0 ? data["5"] : [{typeStr: "中国大陆", type: 1}];
        }
        else {
          this.typeArr = [{typeStr: "男", type: 0}];
          this.areaArr = [{typeStr: "内地", type: 0}];
          this.identityArr = [{typeStr: "演唱", type: 0}];
          this.styleArr = [{typeStr: "流行", type: 0}];
          this.countryArr = [{typeStr: "中国大陆", type: 1}];
        }
      } catch (error) {
        this.typeArr = [{typeStr: "男", type: 0}];
        this.areaArr = [{typeStr: "内地", type: 0}];
        this.identityArr = [{typeStr: "演唱", type: 0}];
        this.styleArr = [{typeStr: "流行", type: 0}];
        this.countryArr = [{typeStr: "中国大陆", type: 1}];
      }
    },
    event() {
      document
        .getElementById("headUpload")
        .addEventListener("change", this.changeHeadImg);
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    changeHeadImg(e) {
      console.log("upload", e);
      const that = this;
      //判断宽高
      let url = window.URL || window.webkitURL;
      let img = new Image(); //手动创建一个Image对象
      img.src = url.createObjectURL(e.target.files[0]); //创建Image的对象的url
      img.onload = function () {
        console.log("height:" + this.height + "----width:" + this.width);
        if (this.height < 500 || this.width < 500) {
          that.clearHeadInput();
          return window.eventEmitter.emit("toast", "图片尺寸需要>500*500像素");
        } else if (e.target.files[0].size > 10 * 1024 * 1000) {
          //判断大小
          that.clearHeadInput();
          return window.eventEmitter.emit("toast", "图片大小不能超过10M");
        } else {
          that.getBase64(e.target.files[0], (res) => {
            that.option.img = res;
            that.cropper = true;
          });
        }
      };
    },
    autoClick() {
      document.getElementById("headUpload").click();
    },
    clearHeadInput() {
      document.getElementById("headUpload").value = "";
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        this.getBase64(data, (res) => {
          this.editHeadImg = res;
          this.cropper = false;
        });
      });
    },
    //检测歌手名是否合法
    async checkName(word) {
      if(!word.trim()) return true
      //字数
      if (word.length > 60) {
        window.eventEmitter.emit('toast', '歌手名请输入小于60字符')
        return false
      }
      //表情 特殊符号
      let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      if (iconRule1.test(word) || iconRule2.test(word)) {
        window.eventEmitter.emit('toast', '请不要输入特殊字符')
        return false
      }
      //敏感词
      let res = ''
      try {
        res = await this.api({
          apiName: 'sensitive',
          postData: {
            word: word
          }
        })
      } catch (error) {
        window.eventEmitter.emit('toast', error.error || '服务器异常')
      }
      if(res.data.data.resultInfo) {
        window.eventEmitter.emit('toast', res.data.data.resultInfo)
        return false
      }
      return true
    },
    //检测简介是否合法
    async checkIntro(word) {
      if(!word.trim()) return true
      //字数
      if (word.length < 10 || word.length > 2000) {
        window.eventEmitter.emit('toast', '简介请输入10-2000字')
        return false
      }
      //表情
      let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      if (iconRule2.test(word)) {
        window.eventEmitter.emit('toast', '请不要输入特殊字符')
        return false
      }
      //敏感词
      let res = ''
      try {
        res = await this.api({
          apiName: 'sensitive',
          postData: {
            word: word
          }
        })
      } catch (error) {
        window.eventEmitter.emit('toast', error.error || '服务器异常')
      }
      if(res.data.data.resultInfo) {
        window.eventEmitter.emit('toast', res.data.data.resultInfo)
        return false
      }
      return true
    },
    async edit() {
      // const tempObj = JSON.parse(JSON.stringify(this.user))
      const tempObj = {
        name: this.user.name,
        idcard: this.user.idcard,
        idcard_pic1: this.user.idcard_pic1,
        idcard_pic2:this.user.idcard_pic2,
        idcard_pic3:this.user.idcard_pic3,
        mobile: this.user.mobile,
        invite_code: this.user.invite_code,
        area: this.user.area,
        country: this.user.country,
        identity: this.user.identity,
        author_name: this.user.author_name,
        gender: this.user.gender,
        genre: this.user.genre,
        avatar: this.user.avatar,
        intro: this.user.intro,
        exists_author_id: this.user.exists_author && this.user.exists_author.author_id || 0,
        external_screenshots: this.user.external_screenshots,
        exists_author_type: this.user.exists_author_type,
        exists_author: this.user.exists_author,
        author_type: this.user.author_type,
        author: this.user.author,
        author_id: this.user.author && this.user.author.author_id || 0,
        id: this.user.id
      }
      Object.assign(tempObj, {
        userid: window.kugouid || 0,
        appid: window.appid,
        token: window.token,
        is_submit: 1
      })
      switch (this.popupType) {
        //头像
        case 1: {
          const uploadRes = await uploadBase64Img(this.editHeadImg);
          if (uploadRes && uploadRes.status == 1) {
            Object.assign(tempObj, {
              avatar: this.replaceHttpsImg(uploadRes.url),
            })
          }
          break
        }
        //歌手名
        case 2: {
          if(!this.editName.trim()) return window.eventEmitter.emit('toast', '请输入歌手名')
          if(!await this.checkName(this.editName)) return
          Object.assign(tempObj, {
            author_name: this.editName
          })
          break
        }
        //性别
        case 3: {
          Object.assign(tempObj, {
            gender: this.editType
          })
          break
        }
        //地区
        case 4: {
          Object.assign(tempObj, {
            area: this.editArea
          })
          break
        }
        //身份
        case 5: {
          Object.assign(tempObj, {
            identity: this.editIdentity
          })
          break
        }
        //简介
        case 6: {
          if(!this.editIntro.trim()) return window.eventEmitter.emit('toast', '请输入简介')
          if(!await this.checkIntro(this.editIntro)) return
          Object.assign(tempObj, {
            intro: this.editIntro
          })
          break
        }
        //流派
        case 7: {
          Object.assign(tempObj, {
            genre: this.editStyle
          })
          break
        }
        default:
          break;
      }
      this.updateUser(tempObj)
      this.popupFlag = false;
    },
    showPopup(type) {
      this.popupType = type;
      this.popupFlag = true;
    },
    closePopup() {
      this.popupFlag = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  .popup-c {
    z-index: 1;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    .popup {
      position: absolute;
      width: 400px;
      height: auto;
      border: 1px solid #ccc;
      background-color: #fff;
      .header {
        height: 40px;
        line-height: 40px;
        background-color: #2c323b;
        font-size: 16px;
        color: #fff;
        position: relative;
        .title {
          margin-left: 15px;
        }
        .close {
          cursor: pointer;
          position: absolute;
          right: 15px;
          top: 10px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
        }
      }
      .main {
        padding: 0 30px;
        background-color: #fff;
        .edit-radio {
          margin-top: 60px;
          text-align: center;
          .el-radio__label {
            font-size: 16px;
            color: #000;
          }
        }
        .edit-text {
          margin-top: 30px;
          input {
            width: calc(100% - 20px);
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
        }
        .edit-textarea {
          margin-top: 30px;
          textarea {
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
        }
        .edit-img {
          font-size: 16px;
          color: #888888;
          p:first-child {
            margin-top: 30px;
          }
          div {
            margin-top: 30px;
            text-align: center;
            img {
              width: 140px;
              height: 140px;
              border-radius: 10px;
            }
          }
        }
        .bottom {
          height: 120px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          > div {
            width: 130px;
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
          }
          .left {
            color: #0090ff;
            border: 1px solid #0090ff;
          }
          .right {
            background-color: #0090ff;
            color: #fff;
          }
        }
      }
    }
  }
  header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    border-radius: 10px;
    background-color: #fff;
    p {
      margin-left: 20px;
      span {
        cursor: pointer;
      }
    }
  }
  > .main {
    position: relative;
    margin-top: 5px;
    border-radius: 10px;
    background-color: #fff;
    height: calc(100vh - 70px);
    overflow: auto;
    .title {
      position: relative;
      margin: 30px 0 0 20px;
      font-size: 18px;
      color: #000;
    }
    .edit {
      margin-left: 20px;
      margin-top: 50px;
      .row {
        position: relative;
        display: flex;
        margin-top: 20px;
        > div {
          position: relative;
          height: 100%;
        }
        .left {
          flex-basis: 100px;
          font-size: 16px;
          color: #000000;
          .label {
          }
        }
        .right {
          font-size: 16px;
          > div {
            display: flex;
            align-items: flex-end;
          }
          .head-img {
            height: 90px;
            img {
              width: 90px;
              height: 90px;
              border-radius: 10px;
            }
          }
          .btn {
            margin-left: 15px;
            width: auto;
            height: 16px;
            line-height: 16px;
            color: #0090ff;
            font-size: 16px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            padding: 10px 15px;
            cursor: pointer;
          }
          .disabled {
            color: rgba(0, 0, 0, 0.3);
          }
          .text {
            width: 450px;
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/EditUser.vue